import React from "react";

import { DeleteRedIcon } from "../../../assets/icons";
import { ProductSettingsListItemDTO } from "../../../models/product/product.response";
import { ProductTagType } from "../../../models/base/ProductTagType";
import { on } from "events";

interface ProductCardProps {
    onEdit: () => void;
    onDelete: () => void;
    product: ProductSettingsListItemDTO;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, onEdit, onDelete }) => {

    return (
        <div className="item-div">
            <div className="item-photo-div">
                {product.imageUrl && (
                    <img src={product.imageUrl + "@sm.webp"} loading="lazy" className="image-5" />
                )}
            </div>
            <div className="item-info-div">
                <div className="item-info-header-div">
                    <div className="item-info-header-name-and-desc-div">
                        <div className="div-block-17">
                            <div className="item-name">{product.name}</div>
                            {product.isDeleted ?
                                (<div className="small-box-div grey-bg">
                                    <div>Neaktivna</div>
                                </div>)
                                : (
                                    <div className="small-box-div green-bg">
                                        <div>Aktivna</div>
                                    </div>
                                )}
                        </div>
                        <div className="item-info-tags-list-div">
                            {product.tags.map((tag, index) => (
                                <div key={index} className="small-box-div tag-box">
                                    <div>{ProductTagType[tag]}</div>
                                </div>
                            ))}
                        </div>
                        <div className="description-text">{product.description}</div>
                        <div className="description-text italic 0.75rem">{product.description2}</div>
                        <div className="item-price">{product.price} RSD</div>
                    </div>
                </div>
                <div className="item-bottom-div">
                    <div className="small-box-div black-bg grow pointer" onClick={onEdit}>
                        <div>Izmeni</div>
                    </div>
                    <div>
                        <img loading="lazy" src={DeleteRedIcon} alt="" className="icon-size-20 pointer" onClick={onDelete} />
                    </div>
                </div>
            </div>
        </div>
    );

};

export default ProductCard;